import { useEffect, useState } from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, FormControl, InputLabel, Box } from "@mui/material";
import bg from "../../../assets/images/Synchro/flags/United-Kingdom.png";
import el from "../../../assets/images/Synchro/flags/Greece.png";
import { styled } from "@mui/system";

const regionOptions = [
  { region: "Ρόδος", code: "ro"},
  { region: "Σύρος", code: "sy"},
  { region: "Κως", code: "ko" },
  { region: "Σύνολο Περιφέρειας", code: "all" },
];

const RegionSelector = () => {
  const [region, setRegion] = useState(() => {
    // initialize from localStorage or default
    return localStorage.getItem("selectedRegion") || "ro"; // default Ρόδος
  });

  const selectedRegion = regionOptions.find(r => r.code === region);

  const CustomSelect = styled(Select)({
    "&::before": { borderBottom: "none !important" },
    "&::after": { borderBottom: "none !important" },
    "&:hover:not(.Mui-disabled, .Mui-error):before": { borderBottom: "none !important" },
    "&:focus, &:active": {
      borderBottom: "none !important",
      outline: "none !important",
    }
  });

  const CustomFormControl = styled(FormControl)({
    borderBottom: "0px solid #000",
    "&:focus, &:active": {
      borderBottom: "0px solid #000 !important",
      outline: "none !important",
    }
  });

  useEffect(() => {
    localStorage.setItem("selectedRegion", region);
  }, [region]);

  const handleRegionChange = (event) => {
    const selectedRegion = event.target.value;
    setRegion(selectedRegion);
  };

  return (
    <CustomFormControl variant="outlined" size="medium" >
      <CustomSelect
        labelId="region-selector-label"
        value={region}
        onChange={handleRegionChange}
        displayEmpty
        renderValue={() => (
          <Box display="flex" alignItems="center" gap={2} sx={{ padding: "10px 10px" }}>
          <span >{selectedRegion?.region || ""}</span>
          <span style={{ fontSize: "12px" }}>▼</span>
          </Box>
        )}
      >
        {regionOptions.map(({ region, code }) => (
          <MenuItem key={code} value={code} sx={{ padding: "10px 20px" }}>
            <Box display="flex" alignItems="center" gap={1}>
             
              <span>{region}</span>
            </Box>
          </MenuItem>
        ))}
      </CustomSelect>
    </CustomFormControl>
  );
};

export default RegionSelector;